var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.record.accessToPersonal
    ? _c(
        "router-link",
        {
          staticClass: "referrals-link-to-brought-employee",
          attrs: {
            to: {
              name: "personal-employee-referrals",
              params: { id: _vm.record.workerId },
            },
            target: "_blank",
          },
        },
        [_vm._v(" " + _vm._s(_vm.cellValue) + " ")]
      )
    : _c("div", { staticClass: "referrals-brought-employee-name" }, [
        _vm._v(" " + _vm._s(_vm.cellValue) + " "),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }